import React from "react";
import { Link, useLocation } from "react-router-dom";
import { getUserProfileSegment } from "../userProfileSidebarMode";

/**
 * Account / dashboard rail (overview, security, KYC, settings, etc.).
 * `walletTypes` is passed from ProfilePage to avoid importing ProfileProvider here
 * (circular deps / HMR can otherwise break hook resolution and throw "_s is not a function").
 * @param {{ toggleContent?: (label: string) => void; walletTypes?: string[] }} props
 */
export default function DashboardSidebar({ toggleContent, walletTypes = [] }) {
  const location = useLocation();
  const seg = getUserProfileSegment(location.pathname);

  const fire = (label) => () => toggleContent?.(label);

  const liActive = (segment) => (seg === segment ? "active mb-1" : "mb-1");

  const settingsActive = seg === "profile_setting" || seg === "notification_settings";

  return (
    <ul className="list-unstyled ps-0 navi_sidebar dashboard-sidebar-root">
      <li className={liActive("dashboard")} onClick={fire("Overview")}>
        <Link to="dashboard">
          {/* <i className="ri-dashboard-line navi_sidebar_icon" aria-hidden="true" /> */}
          <img className="navi_sidebar_icon" src="/images/dashboard_menu_icon.svg" alt="Overview" width={20} height={20} />
          <div className="dashboard_menu_hd">Overview</div>
        </Link>
      </li>

      {/* <li className={walletActive ? "active mb-1" : "mb-1"}>
        <button
          type="button"
          className="btn btn-toggle collapsed"
          onClick={() => setOpenAssets((v) => !v)}
        >
          <i className="ri-wallet-3-line navi_sidebar_icon" aria-hidden="true" />
          <div className={`dashboard_menu_hd ${walletActive ? "active_ul" : ""}`}>Assets</div>
          <span>
            <i className={openAssets ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} aria-hidden="true" />
          </span>
        </button>
        <div className={`collapse ${openAssets ? "show" : ""}`}>
          <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
            <li className={liActive("asset_overview")} onClick={fire("Overview")}>
              <Link to="asset_overview" className="rounded">
                Overview
              </Link>
            </li>
            {["funding", "trading", "margin", "futures"].map((w) => {
              const active =
                location.pathname.includes(`/wallet/${w}`) ||
                location.pathname.endsWith(`/wallet/${w}`);
              const label = capitalizeWallet(w).replace(" Wallet", "");
              const iconSrc =
                w === "funding"
                  ? "/images/security/pocket_icon.svg"
                  : w === "trading"
                    ? "/images/security/pocket_icon2.svg"
                    : w === "margin"
                      ? "/images/security/pocket_icon4.svg"
                      : "/images/security/pocket_icon3.svg";
              return (
                <li
                  key={w}
                  className={active ? "active mb-1" : "mb-1"}
                  onClick={() => toggleContent?.("Overview")}
                >
                  <Link to={`wallet/${w}`} className="rounded d-flex align-items-center gap-2">
                    <img src={iconSrc} alt="" width={18} height={18} />
                    {label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </li> */}

      <li className={liActive("security")} onClick={fire("Security")}>
        <Link to="security">
          {/* <i className="ri-shield-check-line navi_sidebar_icon" aria-hidden="true" /> */}
          <img className="navi_sidebar_icon" src="/images/dashboard_menu_icon2.svg" alt="Security" width={20} height={20} />
          <div className="dashboard_menu_hd">Security</div>
        </Link>
      </li>

      <li className={liActive("kyc")} onClick={fire("Identification")}>
        <Link to="kyc">
          {/* <i className="ri-id-card-line navi_sidebar_icon" aria-hidden="true" /> */}
          <img className="navi_sidebar_icon" src="/images/dashboard_menu_icon3.svg" alt="Individual Verification" width={20} height={20} />
          <div className="dashboard_menu_hd">Individual Verification</div>
        </Link>
      </li>



      <li className={liActive("kyb")} onClick={fire("Business Verification")}>
        <Link to="kyb">
          <img className="navi_sidebar_icon" src="/images/kyb_menu_icon.svg" alt="Business Verification" width={20} height={20} />
          <div className="dashboard_menu_hd">Business Verification</div>
        </Link>
      </li>

      <li className={settingsActive ? "active mb-1" : "mb-1"} onClick={fire("Settings")}>
        <Link to="profile_setting">
          {/* <i className="ri-settings-3-line navi_sidebar_icon" aria-hidden="true" /> */}
          <img className="navi_sidebar_icon" src="/images/security/setting2.svg" alt="Settings" width={20} height={20} />
          <div className="dashboard_menu_hd">Settings</div>
        </Link>
      </li>

      {/* API Key Management — temporarily hidden
      <li className={liActive("api_keys")} onClick={fire("API Key Management")}>
        <Link to="api_keys">
          <i className="ri-key-2-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">API Key Management</div>
        </Link>
      </li>
      */}

      <li className={liActive("notification")} onClick={fire("Notification")}>
        <Link to="notification">
          <i className="ri-notification-3-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Notification</div>
        </Link>
      </li>

      <li className={liActive("activity_logs")} onClick={fire("Activity logs")}>
        <Link to="activity_logs">
          <i className="ri-history-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Activity Logs</div>
        </Link>
      </li>
      <li className={liActive("my_tickets")} onClick={fire("My Tickets")}>
        <Link to="my_tickets" className="d-flex align-items-center gap-2">
          <img className="navi_sidebar_icon" src="/images/security/tickets_icon.svg" alt="" width={20} height={20} />
          <div className="dashboard_menu_hd">My Tickets</div>
        </Link>
      </li>

      {/* <li className={liActive("support")} onClick={fire("Support")}>
        <Link to="support">
          <i className="ri-customer-service-2-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Support</div>
        </Link>
      </li> */}

      {/* <li className="mb-1" onClick={fire("Dashboard")}>
        <Link to="dashboard">
          <i className="ri-group-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Subaccounts</div>
        </Link>
      </li>

      <li className="mb-1" onClick={fire("Dashboard")}>
        <Link to="dashboard">
          <i className="ri-coupon-3-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Vouchers</div>
        </Link>
      </li>

      <li className={liActive("support")} onClick={fire("Support")}>
        <Link to="support">
          <i className="ri-customer-service-2-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">My Tickets</div>
        </Link>
      </li>

      <li className={liActive("profile_setting")} onClick={fire("Settings")}>
        <Link to="profile_setting">
          <i className="ri-settings-3-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Settings</div>
        </Link>
      </li>

      <li className="mb-1" onClick={fire("Earning")}>
        <Link to="/earning">
          <i className="ri-money-dollar-circle-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Earning</div>
        </Link>
      </li>

      <li className={liActive("notification")} onClick={fire("Notification")}>
        <Link to="notification">
          <i className="ri-notification-3-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Notification</div>
        </Link>
      </li>

      <li className={liActive("activity_logs")} onClick={fire("Activity logs")}>
        <Link to="activity_logs">
          <i className="ri-history-line navi_sidebar_icon" aria-hidden="true" />
          <div className="dashboard_menu_hd">Activity logs</div>
        </Link>
      </li> */}
    </ul>
  );
}
